import { CubePresenter, FlipIntent, Logger } from 'wdc-cube'

import { MainPresenter } from 'src/main/Main.presenter'
import UserProfileKeys from 'src/modules/user-profile/up_keys'
import { UserChangePasswordRequestData } from '../../um_scopes'
import { UserManagerService } from '../../um_service'
import { UserManagerFormKeys } from '../um_form_keys'
import { UserChangePasswordFormKeys } from './ucp_form_keys'
import UserChangePasswordFormScope from './ucp_form_scope'
import { generateRandomSequence } from 'src/utils/string.utils'

const LOG = Logger.get('UserChangePasswordFormPresenter')
const userManagerService = UserManagerService.singleton()

export class UserChangePasswordFormPresenter extends CubePresenter<MainPresenter, UserChangePasswordFormScope> {
    // :: Constructor
    public constructor(app: MainPresenter) {
        super(app, new UserChangePasswordFormScope())
    }

    // :: Instance
    #userId?: number
    #origin?: string

    // :: Methods

    public override release() {
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new UserChangePasswordFormKeys(this.app, intent)

        keys.dialogSlot(this.scope)

        LOG.debug(`applyParameters ${keys.userId}`)
        if (initialization) {
            await this.#initialize()
        }

        this.#userId = keys.userId
        this.#origin = keys.origin

        return keys.allow
    }

    public override publishParameters(intent: FlipIntent): void {
        const keys = new UserChangePasswordFormKeys(this.app, intent)
        keys.userId = this.#userId
        keys.origin = this.#origin
        LOG.debug(`publishParameters ${keys.userId}`)
    }

    async #initialize() {
        LOG.debug('initialize')

        this.scope.onCancel = this.action(this.handleCancel)

        this.scope.onSave = this.action(this.handleSave)

        this.scope.onGenerate = this.action(this.handleGenerateNewPassword)
    }

    private async handleCancel() {
        if (this.#origin === 'user-profile') {
            await new UserProfileKeys(this.app).flip()
            return
        }
        await new UserManagerFormKeys(this.app).flip()
    }

    private async handleSave() {
        try {
            const formData = {
                password: this.scope.newPassword,
                passwordConfirmation:
                    this.scope.type === 'password' ? this.scope.confirmNewPassword : this.scope.newPassword,
                sendToEmail: this.scope.sendToEmail
            } as UserChangePasswordRequestData

            if (!formData.password) {
                this.app.notify('warning', 'Nova senha deve ser informada')
                return
            }

            if (formData.password !== formData.passwordConfirmation) {
                this.app.notify('warning', 'Senha e Confirmação de Senha devem ser iguais!')
                return
            }

            const retSalvar = await userManagerService.changeUserPassword(this.#userId!, formData)

            if (retSalvar) {
                const target = new UserManagerFormKeys(this.app)

                await target.flip()
                this.app.notify('success', 'Senha atualizada com sucesso')
            }
        } catch (caught) {
            LOG.error('handleSave', caught)
            throw caught
        }
    }

    private async handleGenerateNewPassword() {
        this.scope.newPassword = generateRandomSequence()
    }
}

export default UserChangePasswordFormPresenter
